import {mySongsPageStore} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";

export interface IFilterGenreControlsLogic {
  handleResetOnClick: () => void;
}

export const useFilterGenreControlsLogic = (): IFilterGenreControlsLogic => {
  return {
    handleResetOnClick: () => mySongsPageStore.resetFilterGenres(),
  };
}
